module.exports = __webpack_public_path__ + "static/media/credit-card.7877324c.svg";